//Variables from AWS validation
const setEnvironmentName = (name) => {
    localStorage.setItem('environment', name);
}

const setApiAccessToken = (accessToken) =>{
    localStorage.setItem('app-user-api-token', accessToken);
}

const getApiAccessToken = () =>{
    return localStorage.getItem('app-user-api-token');
}

//Variables from AWS validation
const setAwsValidation = (token, email, permission) => {
    localStorage.setItem('token', token);
    localStorage.setItem('email', email);
    localStorage.setItem('permisao', permission);
}

const removeAwsValidation = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('email');
    localStorage.removeItem('permisao');
}

//Variables from AzureAd validation
const setAzureAdValidation = (displayName, companyName) => {
    localStorage.setItem('nome', displayName);
    localStorage.setItem('empresa', companyName);
    localStorage.setItem('data', new Date());
}

const removeAzureAdValidation = () => {
    localStorage.removeItem('nome');
    localStorage.removeItem('empresa');
    localStorage.removeItem('data');
}

const setAWSLambdaAuthBasePath = (basePath) => {
    localStorage.setItem('aws-lambda-auth', basePath);
}

const setAWSLambdaBasePath = (basePath) => {
    localStorage.setItem('aws-lambda-main', basePath);
}

const setTerceiroEmail = (email) => {
    localStorage.setItem("email-terceiro", email);
}

const setTerceiroPass = (pass) => {
    localStorage.setItem("pass-terceiro", pass);
}

const getTerceiroPass = () => {
    return localStorage.getItem("pass-terceiro");
}

const getTerceiroEmail = () => {
    return localStorage.getItem("email-terceiro");
}

const setTerceiroUriQrCode = (uri) => {
    localStorage.setItem("qrcode-terceiro", uri);
}

const getTerceiroUriQrCode = () => {
    return localStorage.getItem("qrcode-terceiro");
}

const removeTerceiroData = () => {
    localStorage.removeItem('email-terceiro');
    localStorage.removeItem('qrcode-terceiro');
}

const setRoutePrefix = (prefix) => {
    localStorage.setItem('routePrefix', prefix);
}

const removeAll = () => {

    let msalAccountKeys = localStorage.getItem('msal.account.keys');
    let isInternalUser = msalAccountKeys !== null;

    if(!isInternalUser){
        localStorage.clear();
    }
}

const storage = {
    setEnvironmentName,
    setAwsValidation,
    setAzureAdValidation,
    setAWSLambdaAuthBasePath,
    setAWSLambdaBasePath,
    removeAwsValidation,
    removeAzureAdValidation,
    setTerceiroUriQrCode,
    getTerceiroUriQrCode,
    setTerceiroEmail,
    getTerceiroEmail,
    removeTerceiroData,
    removeAll,
    setRoutePrefix,
    setApiAccessToken,
    getApiAccessToken,
    setTerceiroPass,
    getTerceiroPass
};

export default storage;